module.exports = __webpack_public_path__ + "static/9-b24ef3c79cc49c3319dd990fe7078207.jpeg";